import axios from '@/http/axios';

export default {
  login: (config: any = {}) => {
    return axios.post(`/auth/login`, config);
  },
  details: (config: any = {}) => {
    return axios.get('/auth/details', config);
  },
  adminAttemptLogin: (config: any = {}) => {
    return axios.post(`/auth/adm/login`, config);
  },
  businessAttemptLogin: (config: any = {}) => {
    return axios.post(`/auth/bus/login`, config);
  },
  sendActivationEmail: (config: any = {}) => {
    return axios.put(`/auth/send-activation-email`, config);
  },
  businessSignUp: (config: any = {}) => {
    return axios.post('/auth/bus/sign-up', config);
  },
  businessActivate: (config: any = {}) => {
    return axios.get('/auth/bus/activate', config);
  },
  candidateAttemptLogin: (config: any = {}) => {
    return axios.post('/auth/can/login', config);
  },
  candidateForgotPasswordPreRegister: (config: any = {}) => {
    return axios.post('/auth/can/forgot-password-and-pre-register', config);
  },
  candidateResetPassword: (config: any = {}) => {
    return axios.post('/auth/can/forgot-password', config);
  },
  candidateForgotPassword2fa: (config: any = {}) => {
    return axios.put('/auth/can/forgot-password-2fa', config);
  },
  candidateForgotPasswordResetPassword: (config: any = {}) => {
    return axios.put('/auth/can/reset-password', config);
  },
  businessResetPassword: (config: any = {}) => {
    return axios.post('/auth/bus/forgot-password', config);
  },
  businessResetPassword2fa: (config: any = {}) => {
    return axios.put('/auth/bus/forgot-password-2fa', config);
  },
  businessResetPasswordResetPassword: (config: any = {}) => {
    return axios.put('/auth/bus/reset-password', config);
  },
  adminResetPassword: (config: any = {}) => {
    return axios.post('/auth/adm/forgot-password', config);
  },
  adminResetPassword2fa: (config: any = {}) => {
    return axios.put('/auth/adm/forgot-password-2fa', config);
  },
  adminResetPasswordResetPassword: (config: any = {}) => {
    return axios.put('/auth/adm/reset-password', config);
  },
  logout: (config: any = {}) => {
    return axios.delete('/auth/logout', config);
  },
  update: (config: any = {}) => {
    return axios.put('/auth/update', config);
  },
  changePassword: (config: any = {}) => {
    return axios.put('/auth/change-password', config);
  },
  signature: (config: any = {}) => {
    return axios.put('/auth/signature', config);
  },
  getSignature: (config: any = {}) => {
    return axios.get('/auth/signature', config);
  },
};
